



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
@Component({
    components: {}
})
export default class InspectionForm extends Vue {
    @Prop() inspectionForm: CommonTypes.mapObject;

    checkedDeductionList: string[] = [];
    editForm: CommonTypes.mapObject = [];
    totalCount: number = 0;
    noteSwitch: boolean = false;
    noteRequired: boolean = false;

    @Watch('inspectionForm', { immediate: true, deep: true })
    onFormChanged() {
        if (this.inspectionForm) {
            this.editForm = cloneDeep(this.inspectionForm.deduction);
            (this.inspectionForm.systemFields || []).forEach(item => {
                switch (item.name) {
                    case 'totalPoints':
                        this.totalCount = item.value;
                        break;
                    case 'noteSwitch':
                        this.noteSwitch = item.value;
                        break;
                    case 'noteRequired':
                        this.noteRequired = item.value;
                        break;
                    default:
                        break;
                }
            });
        }
    }

    checkboxChanged(val, item) {
        this.totalCount = val ? this.totalCount - item.value : this.totalCount + item.value;
    }
}
